import React, {useState, useEffect, useMemo} from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import '../styles/global.css'; // Seu CSS global
import axios from 'axios';
import { CircularProgress } from '@mui/material'
import { SwapVert, ThumbUpAlt, ThumbDownOffAlt,Visibility, VisibilityOff } from '@mui/icons-material';
import MenuAssociados from '../components/MenuAssociados';

function Votacoes() {
    const [votacoes, setVotacoes] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const loggedInUser = sessionStorage.getItem('loggedIn');
    const [selectedPosicao, setSelectedPosicao] = 
    useState(sessionStorage.selectPosicaoVotacao 
        && sessionStorage.selectPosicaoVotacao !== undefined 
        ? sessionStorage.selectPosicaoVotacao : 'ANDAMENTO'); //useState('ANDAMENTO');
    //sessionStorage.selectPosicaoVotacao && sessionStorage.selectPosicaoVotacao !== 'undefined' ? sessionStorage.selectPosicaoVotacao : 'ANDAMENTO'
    const [resultados, setResultados] = useState('');
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";

    const now = new Date();
    const customFormatDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens

    //ordenação do resultado pessoas
    
    const useSortableData = (items, config = null) => {
    const [sortConfig, setSortConfig] = useState(config);

    const sortedItems = useMemo(() => {
        let sortableItems = [...items];
        if (sortConfig !== null) {
        sortableItems.sort((a, b) => {
            if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
            }
            if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
            }
            return 0;
        });
        }
        return sortableItems;
    }, [items, sortConfig]);

    const requestSort = key => {
        let direction = 'ascending';
        if (sortConfig && 
        sortConfig.key === key && 
        sortConfig.direction === 'ascending'
        ) {
        direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    return { items: sortedItems, requestSort, sortConfig };
    };
    const { items, requestSort, sortConfig } = useSortableData(votacoes);

    const getClassNamesFor = name => {
    if (!sortConfig) {
        return;
    }
    return sortConfig.key === name ? sortConfig.direction : undefined
    }

    function handleSelectPosicao(event) {
        const posicao = event.target.value;
        sessionStorage.selectPosicaoVotacao = posicao;
        setSelectedPosicao(posicao);
    }

    function handleEditarVotacao(votacao) {
        if (parseInt(sessionStorage.pesAdmin) === 1) {
            sessionStorage.selectVotacao = votacao.IdVotacao;
            navigate(`/Votacao/${votacao.IdVotacao}/0`);
        }
        else {
            //encaminhar para Votar passando IdVotacao e pesCodigoGUID
            sessionStorage.selectVotacao = votacao.IdVotacao;
            navigate(`/Votar/${votacao.IdVotacao}/${sessionStorage.pesCodigoGUID}/votacoes`);
        }
    }

    function handleAdminVotar(votacao) {
        sessionStorage.selectVotacao = votacao.IdVotacao;
        navigate(`/Votar/${votacao.IdVotacao}/${sessionStorage.pesCodigoGUID}/votacoes`);
    }

    function pesquisar(valor) {
        setSearchTerm(valor);
    }

    function handleVisualizarResultado(votacao) {
        sessionStorage.selectVotacao = votacao.IdVotacao;
        navigate(`/Resultado/${votacao.IdVotacao}`);
    }

    //carregar votações
    useEffect(() => {
        if (sessionStorage.selectPosicaoVotacao && sessionStorage.selectPosicaoVotacao !== null)
            setSelectedPosicao(sessionStorage.selectPosicaoVotacao);
        else
            setSelectedPosicao('ANDAMENTO');

        const dados = {
            IdVotacao: 0,
            IdAssembleia: 0,
            IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
        };
        axios
        .post(
            process.env.REACT_APP_API_URL + 
            '/routes.php?metodo=obtemVotacoes', 
            JSON.stringify(dados),
            {
            headers: {
                "X-Access-Token" : tokenAPI,
                "Content-Type": "application/json; charset=UTF-8"
            }
        })
        .then(response => {
            if (response.data){
                setVotacoes(response.data);
                setIsLoading(false);
            } else {
                console.log('Nenhuma votação encontrada.');
                setIsLoading(false);
                navigate('/Votacoes');
            }
            
        })
        .catch(error => {
            console.error('Erro ao carregar votações: ', error.message);
            setIsLoading(false);
        });
    }, []);

    //obter resultado da votação
    useEffect(() => {
        const dados = {
            IdVotacao: 0,
        };
        axios
        .post(
            process.env.REACT_APP_API_URL + 
            '/routes.php?metodo=ObtemResultadoVotacao', 
            JSON.stringify(dados),
            {
            headers: {
                "X-Access-Token" : tokenAPI,
                "Content-Type": "application/json; charset=UTF-8"
            }
        })
        .then(response => {
            if (response.data){
                setResultados(response.data);
            } else {
                console.log('Nenhum resultado encontrado.');
            }
        })
        .catch(error => {
            console.error('Erro ao carregar resultado: ', error.message);
        });
    }, []);
    //ordenar votações por IdVotacao desc
    useEffect(() => {
        setVotacoes(prevVotacoes => {
            const sortedVotacoes = [...prevVotacoes];
            sortedVotacoes.sort((a, b) => b.IdVotacao - a.IdVotacao);
            return sortedVotacoes;
        });
    }, []);

    //salvar log de navegacao
    useEffect(() => {
        const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        const log = {
            IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
            logTipo: "Navegação",
            logModulo: "Página de Votacoes",
            logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
            logCriadoEm: new Date().toISOString(),
            logCodigoGUID: crypto.randomUUID()
        };
        axios                    
        .post(process.env.REACT_APP_API_URL 
            + '/routes.php?metodo=novoLog', 
            log, {
                headers: {
                    "X-Access-Token" : tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                }
            }
        )
        .then(response => {
            //console.log(response.data[0].mensagem);
        })
        .catch(error => {
            console.error('Erro ao enviar log:', error);
        });
    }, []);

    //identificar a resolução da tela para ajustar o tamanho da tabela
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
        setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    //vai para linha de foco após edição
    useEffect(() => {
        const itemClicadoId = sessionStorage.getItem('selectVotacao');

        if (itemClicadoId) {
            const elementoLinha = document.getElementById(`votacao-${itemClicadoId}`);
            
            if (elementoLinha) {
            // Rola até a linha clicada de forma suave
            setTimeout(() => {
                elementoLinha.scrollIntoView({ behavior: 'smooth', block: 'center' });
                // Destaque visual temporário opcional (ex: piscar a linha)
                elementoLinha.style.backgroundColor = '#fff9c4'; 
                setTimeout(() => elementoLinha.style.backgroundColor = '', 3000);
            }, 100); // Um pequeno delay garante que o HTML já renderizou

            // 2. Limpa o ID para não rolar de novo se o usuário atualizar a página (F5)
            sessionStorage.removeItem('selectVotacao');
            }
        }
    }, [votacoes]);

    //console.log(sessionStorage.selectPosicaoVotacao);

    return (
        <div style={{ paddingBottom: '80px'}}>
            <main style={{paddingBottom: '80px'}}>
                <div>
                    <div>
                        <MenuAssociados />
                    </div>
                    <div className="headerMain">
                        <label className="labelTitulo">Votações</label>
                        <span style={{ color: 'white', fontWeight: 'bold', fontSize: '18px', marginTop: '20px' }}>Acompanhe os rumos do nosso grupo.</span>
                        <span style={{ color: 'orange', fontWeight: 'bold', fontSize: '16px', marginTop: '20px' }}>SUA PARTICIPAÇÃO É FUNDAMENTAL NAS DECISÕES IMPORTANTES!</span>
                        {/* <hr style={{ marginTop: '20px', marginBottom: '20px', width: '100%' }} /> */}
                    </div>
                    <div className="containerBarraPesquisa">
                        {parseInt(sessionStorage.pesAdmin) === 1 ? (
                            <Link to="/Votacao/0/0">
                                <button className="buttonModalPadrao" >
                                    NOVA VOTAÇÃO
                                </button>
                            </Link> ) : ('')}
                        <input className="inputBarraPesquisa"
                            placeholder="PESQUISAR"
                            type="text"
                            id="inputPesquisa"
                            name="inputPesquisa"
                            onChange={event => {
                                pesquisar(event.target.value);
                            }}
                        />

                        <select 
                            className="selectStatusPesquisa"
                            name="selectStatusRegistroAssociado"
                            value={selectedPosicao !== 'undefined' ? selectedPosicao : ''}
                            onChange={event => {
                                handleSelectPosicao(event)
                            }}
                            >
                            <option value={'TODOS'} >TODOS</option>
                            <option value={'PENDENTE'} >PENDENTE</option>
                            <option value={'ANDAMENTO'} >ANDAMENTO</option>
                            <option value={'CANCELADO'} >CANCELADO</option>
                            <option value={'FINALIZADO'} >FINALIZADO</option>
                        </select>
                    </div>
                </div>

                <div className="tabelaPadrao">
                    {windowWidth < 768 ? (
                        // Renderização para telas menores que 769px
                        isLoading ? <div><CircularProgress /></div> : 
                        items
                        .filter(votacao => {
                            if (searchTerm === '') {
                                if (selectedPosicao === '') {
                                    return votacao;
                                } else if (selectedPosicao === 'PENDENTE') {
                                    return votacao.vtcPosicao === 'PENDENTE';
                                } else if (selectedPosicao === 'ANDAMENTO') {
                                    return votacao.vtcPosicao === 'ANDAMENTO';
                                } else if (selectedPosicao === 'CANCELADO') {
                                    return votacao.vtcPosicao === 'CANCELADO';
                                } else if (selectedPosicao === 'FINALIZADO') {
                                    return votacao.vtcPosicao === 'FINALIZADO';
                                } else {
                                    return votacao;
                                }
                            
                            } else if (
                                votacao.vtcTitulo.toLowerCase().includes(searchTerm.toLowerCase())
                                || votacao.vtcDescricao.toLowerCase().includes(searchTerm.toLowerCase())
                            ) {
                                return votacao;
                            }
                            return false; // Adicionado para garantir que o filtro retorne um valor booleano em todos os casos
                        })
                        .map(votacao => (
                        <div style={{borderBottom: '1px solid #ccc', margin: '10px', backgroundColor: '#dfdada', borderRadius: '5px', padding: '10px' }}>
                            <div key={votacao.IdVotacao} id={`votacao-${votacao.IdVotacao}`}>
                                <p onClick={() => handleEditarVotacao(votacao)} style={{ color: '#000' }}><b>TÍTULO: </b>{votacao.vtcTitulo}</p>
                                <p onClick={() => handleEditarVotacao(votacao)} style={{ color: '#000', marginTop: '10px' }}><b>DESCRIÇÃO: </b>{votacao.vtcDescricao}</p>
                                <p onClick={() => handleEditarVotacao(votacao)} style={{ color: '#000', marginTop: '10px' }}><b>DATA INÍCIO: </b>{new Date(votacao.vtcDataInicio).toLocaleDateString('pt-BR', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit'
                                            }).replace(',','')}</p>
                                <p onClick={() => handleEditarVotacao(votacao)} style={{ color: '#000', marginTop: '10px' }}><b>DATA FINAL: </b>{new Date(votacao.vtcDataFinal).toLocaleDateString('pt-BR', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit'
                                            }).replace(',','')}</p>
                                <p onClick={() => handleAdminVotar(votacao)} style={{ color: '#000', marginTop: '10px' }}><b>POSIÇÃO: </b>{votacao.vtcPosicao === 'PENDENTE' ? 'NÃO INICIADO' : votacao.vtcPosicao}</p><br />
                                {votacao && votacao.vtcPosicao === "ANDAMENTO" && votacao.IdVotoRegistrado > 0 ? (
                                    <p onClick={() => handleAdminVotar(votacao)} style={{ color: '#000', marginTop: '10px' }}><b>VOTO: </b>Voto Registrado</p>
                                ) : votacao && votacao.vtcPosicao === "ANDAMENTO" && new Date(votacao.vtcDataFinal) < new Date() ? (
                                    <p style={{ color: '#000', marginTop: '10px' }}><b>VOTO: </b>Votação Encerrada</p>
                                    ) : votacao && votacao.vtcPosicao === "ANDAMENTO" && new Date(votacao.vtcDataInicio) > new Date() ? (
                                        <p style={{ color: '#000', marginTop: '10px' }}><b>VOTO: </b>Votação Ainda Não Iniciada</p>
                                    ) : votacao && votacao.vtcPosicao === "ANDAMENTO" && new Date(votacao.vtcDataInicio) <= new Date() && new Date(votacao.vtcDataFinal) >= new Date() ? (
                                        <p onClick={() => handleAdminVotar(votacao)} style={{ color: '#000', marginTop: '10px' }}><b>VOTO: </b>Votação Em Andamento</p>
                                    ) : votacao.vtcPosicao === "FINALIZADO" ? (
                                        <p style={{ color: '#000', marginTop: '10px' }}><label onClick={() => handleVisualizarResultado(votacao)}><b>VOTAÇÃO: </b>Votação Encerrada <Visibility style={{ verticalAlign: 'middle', marginLeft: '5px' }} /></label> <br /><br />
                                        {resultados ? resultados.filter(resultado => resultado.IdVotacao === votacao.IdVotacao).map((resultado, index) => (
                                                <div key={index}>
                                                    <b>{resultado.vtcOpcao.split(',')[0]}</b> - <b>{resultado.total}</b> {resultado.total > 1 ? 'votos' : 'voto'}.<br /><br />
                                                </div>
                                            )) : null}</p>
                                    ) : (
                                        <p></p>
                                    )
                                }
                            </div>
                        </div>
                        ))
                    ) : (
                        // Renderização para telas maiores ou iguais a 769px
                        //
                        <table className="tabelaDados">
                            <thead>
                                <tr style={{ cursor: 'pointer' }}>
                                    <th style={{ textAlign: "center" }} onClick={() => requestSort('IdVotacao')} className={getClassNamesFor('IdVotacao')}>Número</th>
                                    <th style={{ textAlign: "left" }} onClick={() => requestSort('vtcTitulo')} className={getClassNamesFor('vtcTitulo')}>Título</th>
                                    <th style={{ textAlign: "left" }} onClick={() => requestSort('vtcDataInicio')} className={getClassNamesFor('vtcDataInicio')}>Data Inicio</th>
                                    <th style={{ textAlign: "left" }} onClick={() => requestSort('vtcDataFinal')} className={getClassNamesFor('vtcDataFinal')}>Data Final</th>
                                    <th style={{ textAlign: "left" }} onClick={() => requestSort('vtcPosicao')} className={getClassNamesFor('vtcPosicao')}>Posição</th>
                                    <th style={{ textAlign: "left" }} onClick={() => requestSort('IdVotoRegistrado')} className={getClassNamesFor('IdVotoRegistrado')}>Votação</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                isLoading ? <div><CircularProgress /></div> :    
                                    items
                                    .filter(votacao => {
                                        if (searchTerm === '') {
                                            if (selectedPosicao === '') {
                                                return votacao;
                                            } else if (selectedPosicao === 'PENDENTE') {
                                                return votacao.vtcPosicao === 'PENDENTE';
                                            } else if (selectedPosicao === 'ANDAMENTO') {
                                                return votacao.vtcPosicao === 'ANDAMENTO';
                                            } else if (selectedPosicao === 'CANCELADO') {
                                                return votacao.vtcPosicao === 'CANCELADO';
                                            } else if (selectedPosicao === 'FINALIZADO') {
                                                return votacao.vtcPosicao === 'FINALIZADO';
                                            } else {
                                                return votacao;
                                            }
                                        
                                        } else if (
                                            votacao.vtcTitulo.toLowerCase().includes(searchTerm.toLowerCase())
                                            || votacao.vtcDescricao.toLowerCase().includes(searchTerm.toLowerCase())
                                        ) {
                                            return votacao;
                                        }
                                        return false; // Adicionado para garantir que o filtro retorne um valor booleano em todos os casos
                                    })
                                    .map(votacao => (
                                        <tr style={{ cursor: 'pointer' }} id={`votacao-${votacao.IdVotacao}`} key={votacao.IdVotacao}>
                                            <td style={{ textAlign: 'center' }} onClick={() => handleEditarVotacao(votacao)}>{votacao.IdVotacao}</td>
                                            <td onClick={() => handleEditarVotacao(votacao)}>{votacao.vtcTitulo}</td>
                                            <td onClick={() => handleEditarVotacao(votacao)}>{new Date(votacao.vtcDataInicio).toLocaleDateString('pt-BR', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit'
                                            }).replace(',','')}</td>
                                            <td onClick={() => handleEditarVotacao(votacao)}>{new Date(votacao.vtcDataFinal).toLocaleDateString('pt-BR', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit'
                                            }).replace(',','')}</td>
                                            <td onClick={() => handleEditarVotacao(votacao)}>{votacao.vtcPosicao}</td>
                                            {votacao && votacao.vtcPosicao === "ANDAMENTO" && votacao.IdVotoRegistrado > 0 ? (
                                                <td onClick={() => handleAdminVotar(votacao)}>Voto Registrado</td>
                                            ) : (
                                                votacao.vtcPosicao === "ANDAMENTO" && new Date(votacao.vtcDataInicio) <= new Date() && new Date(votacao.vtcDataFinal) >= new Date() ? 
                                                (
                                                    <td onClick={() => handleAdminVotar(votacao)}>VOTAR</td>
                                                ) : votacao.vtcPosicao === "ANDAMENTO" && new Date(votacao.vtcDataFinal) < new Date() ? (
                                                    <td>Votação Encerrada</td>
                                                ) : (
                                                    votacao.vtcPosicao === "FINALIZADO" ? (
                                                        <td style={{ cursor: 'pointer' }} onClick={() => handleVisualizarResultado(votacao)}><label ><b>VOTAÇÃO: </b>Votação Encerrada <Visibility style={{ verticalAlign: 'middle', marginLeft: '5px' }} /></label><br /><br />
                                                        {resultados ? resultados.filter(resultado => resultado.IdVotacao === votacao.IdVotacao).map((resultado, index) => (
                                                            <div key={index}>
                                                                <b>{resultado.vtcOpcao.split(',')[0]}</b> - <b>{resultado.total}</b> {resultado.total > 1 ? 'votos' : 'voto'}.<br /><br />
                                                            </div>
                                                        )) : null}
                                                        </td>
                                                    ) : (
                                                        votacao.vtcPosicao === "PENDENTE" ? (
                                                            <td>Votação Não Iniciada</td>
                                                        ) : (
                                                            <td></td>
                                                        )
                                                    ) 
                                                )
                                            )}
                                        </tr>
                                    )
                                )}
                            </tbody>
                        </table>
                    )}
                </div>
            </main>
        </div>
    );
}

export default Votacoes;